import { useState } from 'react';
import Modal from '@components/styled-UI/Modal';
import SearchDoctorModal from './SearchDoctorModal';
import { getLabelFallback } from '@utils/utils';
import * as actions from '@redux-actions/';
import { useDispatch } from 'react-redux';
import CrossIcon from '@images/svg-icons/crossIcon.svg';

type DoctorDetailsProps = {
    findDoctorError: boolean;
    doctor;
    setDoctor;
};

const DoctorDetails = (props: DoctorDetailsProps) => {
    const dispatch = useDispatch();

    const [isModalOpen, setIsModalOpen] = useState(false);

    const close = () => {
        setIsModalOpen(false);
        dispatch(actions.setOpenModalAddDoctor(false));
    };

    return (
        <div className="doctor-details">
            <div className="section-title">
            <div className="left">YOUR DOCTOR’S DETAILS</div>
                {!!props.doctor && (
                    <div
                        className="right"
                        onClick={e => {
                            e.preventDefault();
                            setIsModalOpen(true);
                        }}
                    >
                        {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_SEARCH_AGAIN')}
                    </div>
                )}
            </div>

            {!!props.doctor == false && (<div className="section-subtitle mb-24">
                The doctor’s details need to be those of the doctor who issued and signed your prescription.
            </div>)}

            {!!props.doctor && (
                <div
                    className="find-your-doctor-mobile"
                    onClick={e => {
                        e.preventDefault();
                        setIsModalOpen(true);
                    }}
                >
                    {getLabelFallback('MYPROFILE_MY_PRESCRIPTIONS_SEARCH_AGAIN')}
                </div>
            )}

            {!props.doctor && (
                <button
                    className="primary-button-negative small"
                    data-element-id="MyPrescription_FindDoctor"
                    onClick={e => {
                        e.preventDefault();
                        setIsModalOpen(true);
                    }}
                >
                    Find your doctor
                </button>
            )}

            {!!props.doctor && (
                <div className="doctor-data-table-container">
                    <div className="headers-row">
                        <div className="doctor-name-header">
                            <div className="doctor-name">DOCTOR NAME</div>
                        </div>
                        <div className="clinic-name-header">
                            <div className="clinic-name">CLINIC NAME</div>
                        </div>
                        <div className="address-header">
                            <div className="address">ADDRESS</div>
                        </div>
                    </div>
                    <div className="values-row">
                        <div className="doctor-name-value">
                            <div className="full-name">
                                <div className="doctor-firstName-value">
                                    <div className="firstName">
                                        {!!props.doctor.name && props.doctor.name}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="clinic-name-value">
                            <div className="clinic-name">
                                {!!props.doctor.officeName && props.doctor.officeName}
                            </div>
                        </div>
                        <div className="address-value">
                            <div className="address">
                                {!!props.doctor.address?.address1 && (
                                    <div className="address-street-and-city-value-container">
                                        <div className="address-street-value">
                                            <div className="address-street">
                                                {!!props.doctor.address?.address1 &&
                                                    props.doctor.address?.address1}
                                            </div>
                                        </div>
                                        <div className="address-city-value">
                                            <div className="address-city">
                                                {!!props.doctor.address?.city && props.doctor.address.city},{' '}
                                                {!!props.doctor.address?.state &&
                                                    props.doctor.address.state}{' '}
                                                <br />
                                                {!!props.doctor.address?.zipPostalCode &&
                                                    props.doctor.address.zipPostalCode}, {' '}
                                                {!!props.doctor.address?.country && props.doctor.address.country}
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {!!props.doctor.address?.address1 === false && (!!props.doctor.address?.city || !!props.doctor.address?.state || !!props.doctor.address.zipPostalCode ) && (
                                    <div className="address-street-and-city-value-container">
                                        <div className="address-city-value">
                                            <div className="address-city">
                                                {!!props.doctor.address?.city && props.doctor.address?.city}{' '}
                                                {!!props.doctor.address?.state &&
                                                    props.doctor.address.state}
                                                <br />
                                                {!!props.doctor.address?.zipPostalCode &&
                                                    props.doctor.address.zipPostalCode}, {' US'}
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {!!props.doctor.address?.address1 === false && !!props.doctor.address?.city === false && !!props.doctor.address?.state === false && !!props.doctor.address.zipPostalCode === false && (
                                    <div className="address-street-and-city-value-container">
                                        <div className="address-city-value">
                                            <div className="address-city">
                                                {!!props.doctor?.address && props.doctor.address.split(',')[0]}{', '}
                                                <br />
                                                {!!props.doctor?.address &&
                                                    props.doctor.address.split(',')[1].trim().split(' ')[0]}{' '}
                                                {!!props.doctor?.address &&
                                                    props.doctor.address.split(',')[1].trim().split(' ')[1]}, {' US'}
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <div className="address-phone-value-container">
                                    <div className="address-phone-value">
                                        <div className="address-phone">
                                            {!!props.doctor.phoneNumber &&
                                                props.doctor.phoneNumber.replace('-', '')}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {props.findDoctorError && (
                <div className="find-doctor-error">You need to choose a doctor.</div>
            )}

            {!!isModalOpen && (
                <>
                    <div className="background-layer" onClick={close}></div>
                    <div className="modal-container modal--centred">
                        <div className="modal-content">
                            <button
                                aria-label="Close button"
                                className="icon-container"
                                onClick={close}
                            >
                                <CrossIcon />
                            </button>

                            <SearchDoctorModal
                                doctor={props.doctor}
                                setDoctor={props.setDoctor}
                                close={() => setIsModalOpen(false)}
                            />
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default DoctorDetails;
